import { useCallback } from 'react';

export const useCanvasDrag = ({
  currentImage,
  updateCurrentImage,
  canvasRef,
  canvasZoom,
  setHasUnsavedChanges,
}) => {
  const handleMouseDown = useCallback((e) => {
    // Handle drag logic
  }, []);

  const getResizeHandles = useCallback(() => {
    return [];
  }, []);

  return {
    handleMouseDown,
    getResizeHandles,
  };
};
